/* eslint-disable import/no-cycle */
import React from 'react'

import { connect } from 'react-redux'

import BanksSlider from 'components/banks-slider'
import banner from 'containers/corporate-agreements/assets/corporateAgreements.jpg'
import bannerMobile from 'containers/corporate-agreements/assets/corporateAgreementsMobile.jpg'
import { isTablet, isEmpty } from 'helpers/utils'
import { getCorporateLoginData } from 'selectors/corporate/login'
import { mapMediaType } from 'selectors/mediaType'

import {
  PageContent,
  TopContainer,
  TopContentWrapper,
  MobileBannerContainer,
  BottomContainer
} from './styled'

const PageContentWrapper = props => {
  const background = isTablet(props.mediaType) ? bannerMobile : banner
  return (
    <PageContent>
      <TopContainer bkg={background}>
        <TopContentWrapper>
          <MobileBannerContainer bkg={bannerMobile} />
          {props.top}
        </TopContentWrapper>
      </TopContainer>
      {!isEmpty(props.loginData) && <BanksSlider />}
      <BottomContainer>{props.children}</BottomContainer>
    </PageContent>
  )
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state),
  loginData: getCorporateLoginData(state)
})

export default connect(mapStateToProps)(PageContentWrapper)
